import type {
  MindstringPrototype,
  SortOrder,
  ActiveSourceType,
  ThoughtGrouping,
} from "@/generated/fastapi";
import type {
  ActiveStudioContentType,
  ActiveStudioMaintenanceMode,
  ActiveBacklogViewType,
  QuestionnaireViewMode,
} from "@/shared/types";
export type QuestionnaireViewModeSetting = QuestionnaireViewMode;

export const DEFAULT_ACTIVE_PROTOTYPE_CATEGORY =
  "job_activity" as MindstringPrototype;
export const DEFAULT_ACTIVE_STUDIO_GROUPING = "by_situation" as ThoughtGrouping;
export const DEFAULT_ACTIVE_STUDIO_CONTENT =
  "confirmed" as ActiveStudioContentType;
export const DEFAULT_ACTIVE_STUDIO_EXPORT_LOCK = false;
export const DEFAULT_ACTIVE_STUDIO_MAINTENANCE_MODE =
  "none" as ActiveStudioMaintenanceMode;
export const DEFAULT_QUESTIONNAIRE_VIEW_MODE: QuestionnaireViewModeSetting =
  "thought-oriented";

export const DEFAULT_ACTIVE_SOURCE_TYPE = "website" as ActiveSourceType;
export const DEFAULT_SORT_ORDER = "descending" as SortOrder;
export const DEFAULT_ACTIVE_BACKLOG_VIEW = "extract" as ActiveBacklogViewType;

export const DEFAULT_VISIBLE_ORIGINS_COUNT_MINIMUM = 10;
export const DEFAULT_ADDITIONAL_ORIGINS_FETCH_LIMIT = 10;

export const MINSTRING_MIN_LENGTH = 5;
export const MINSTRING_MAX_LENGTH = 225;
export const ORIGIN_MIN_LENGTH = 30;

export const SEARCH_ROOT_MARGIN = "200px";
export const SEARCH_THRESHOLD = 0;
export const SEARCH_HITS_PER_PAGE = 10;
export const SEARCH_RESULT_PREVIEW_LENGTH = 200;

export const appSettings = Object.freeze({
  default: {
    activePrototypeCategory: DEFAULT_ACTIVE_PROTOTYPE_CATEGORY,
    activeStudioGrouping: DEFAULT_ACTIVE_STUDIO_GROUPING,
    activeStudioContent: DEFAULT_ACTIVE_STUDIO_CONTENT,
    activeStudioExportLock: DEFAULT_ACTIVE_STUDIO_EXPORT_LOCK,
    activeStudioMaintenanceMode: DEFAULT_ACTIVE_STUDIO_MAINTENANCE_MODE,
    questionnaireViewMode: DEFAULT_QUESTIONNAIRE_VIEW_MODE,
    activeSourceType: DEFAULT_ACTIVE_SOURCE_TYPE,
    sortOrder: DEFAULT_SORT_ORDER,
    activeBacklogView: DEFAULT_ACTIVE_BACKLOG_VIEW,
    visibleOriginsCountMinimum: DEFAULT_VISIBLE_ORIGINS_COUNT_MINIMUM,
    additionalOriginsFetchLimit: DEFAULT_ADDITIONAL_ORIGINS_FETCH_LIMIT,
  },
  validation: {
    MINSTRING_MIN_LENGTH,
    MINSTRING_MAX_LENGTH,
    ORIGIN_MIN_LENGTH,
  },
  search: {
    ROOT_MARGIN: SEARCH_ROOT_MARGIN,
    THRESHOLD: SEARCH_THRESHOLD,
    HITS_PER_PAGE: SEARCH_HITS_PER_PAGE,
    SEARCH_RESULT_PREVIEW_LENGTH,
  },
});

export default appSettings;
